
define('inlineSvg!svgs/icon/cross', function () {return '<span class="inline-cross inline-icon"><svg width="18" height="18" viewBox="0 0 18 18"><path d="M7.5 9L1 2l1-1 7 6.5L16 1l1 1-6.5 7 6.5 7-1 1-7-6.5L2 17l-1-1 6.5-7z"/></svg></span>';});

